import { Badge, Button, HStack, Text } from '@chakra-ui/react';
import { Xmark } from 'iconoir-react';

import type { DashboardTableFilterItem } from './dashboard-table-utils';

interface DashboardTableActiveFiltersProps {
  items: DashboardTableFilterItem[];
  clearLabel: string;
  emptyLabel?: string;
}

export const DashboardTableActiveFilters = ({
  items,
  emptyLabel,
  clearLabel,
}: DashboardTableActiveFiltersProps) => {
  if (items.length === 0) {
    return emptyLabel ? (
      <Text fontSize="sm" color="fg.muted">
        {emptyLabel}
      </Text>
    ) : null;
  }

  return (
    <HStack gap={2} wrap="wrap">
      {items.map((item) => (
        <Badge key={item.key} size="md" variant="subtle" colorPalette="gray">
          <HStack gap={1.5} minW={0}>
            <Text as="span" fontWeight="medium">
              {item.label}
            </Text>
            <Text as="span" color="fg.muted" truncate maxW="220px">
              {item.value}
            </Text>
            {item.onClear && (
              <Button
                type="button"
                size="2xs"
                variant="ghost"
                minW={0}
                h={5}
                px={1}
                aria-label={`${clearLabel}: ${item.label}`}
                onClick={item.onClear}
              >
                <Xmark width={12} height={12} />
              </Button>
            )}
          </HStack>
        </Badge>
      ))}
    </HStack>
  );
};
